import "./Overview.scss";

interface KpiCard {
  label: string;
  value: number;
}

const kpis: KpiCard[] = [
  { label: "Firmen", value: 5 },
  { label: "Kontakte", value: 3 },
  { label: "Objekte", value: 4 },
  { label: "Mandanten", value: 1 },
];

function Overview() {
  return (
    <section className="crm-overview">
      <header className="crm-overview__header">
        <h1 className="crm-overview__title">Übersicht</h1>
        <p className="crm-overview__subtitle">Kennzahlen des Plattform-Cores</p>
      </header>

      <div className="crm-overview__kpi-grid">
        {kpis.map((kpi) => (
          <article key={kpi.label} className="crm-overview__kpi-card">
            <span className="crm-overview__kpi-label">{kpi.label}</span>
            <span className="crm-overview__kpi-value">{kpi.value}</span>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Overview;
